var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppostrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "indigo",
    fillRule: "evenodd",
    d: "M8.087 0a8.087 8.087 0 1 0 2.8 15.678c-1.3 1.993-3.113 3.6-5.244 4.435a11.278 11.278 0 0 1-4.078.757 1.565 1.565 0 0 0 0 3.13c1.782 0 3.538-.32 5.207-.965l.01-.005c5.794-2.275 9.473-8.604 9.392-14.693v-.25c0-.582-.063-1.148-.178-1.696l-.005-.018A8.09 8.09 0 0 0 8.087 0Zm23.478 0a8.087 8.087 0 1 0 2.8 15.678c-1.3 1.993-3.113 3.6-5.244 4.435a11.279 11.279 0 0 1-4.077.757 1.565 1.565 0 1 0 0 3.13c1.781 0 3.537-.32 5.206-.965l.008-.005c5.797-2.275 9.475-8.604 9.394-14.693v-.25c0-.582-.062-1.148-.177-1.696l-.005-.018A8.09 8.09 0 0 0 31.565 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppostrophy);
export default __webpack_public_path__ + "static/media/appostrophy.d85af9c2b2f0898f473b86015effc0f6.svg";
export { ForwardRef as ReactComponent };